import { render, staticRenderFns } from "./Put.vue?vue&type=template&id=51a68130&"
import script from "./Put.vue?vue&type=script&lang=js&"
export * from "./Put.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports